export const headerHeight = '60px';
export const mobileHeaderHeight = '50px';
export const footerHeight = '50px';

export const appMinWidth = '720px';


// WEBPACK FOOTER //
// ./src/styles/constants.js